/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable prefer-let/prefer-let */
function styleInject(css) {
    if (!css || typeof document === 'undefined') {
        return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    var lastInsertedElement = window._lastElementInsertedByStyleLoader;
    style.type = 'text/css';

    if (!lastInsertedElement) {
        head.insertBefore(style, head.firstChild);
    } else if (lastInsertedElement.nextSibling) {
        head.insertBefore(style, lastInsertedElement.nextSibling);
    } else {
        head.appendChild(style);
    }

    window._lastElementInsertedByStyleLoader = style;

    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

export { styleInject as default };
